import { colors, fonts } from 'theme'
import css from 'styled-jsx/css'

export const stepItem = css.global`
  .step-item-container {
    display: flex;
    position: relative;
    flex-direction: column;
    align-items: center;
  }

  .icon-container {
    position: relative;
  }

  .step-icon {
    position: absolute;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1px solid ${colors.borderInput};
    font: ${fonts.medium};
    font-size: 1.5rem;
    color: ${colors.borderInput};
    top: 0;
    left: 50%;
    margin-left: -20px;
    background-color: ${colors.white};
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .step-icon.number {
    color: ${colors.primary};
    border-color: ${colors.primary};

    visibility: visible;
    opacity: 1;
    transition: 120ms opacity;
  }

  .icons {
    position: relative;
    height: 40px;
    width: 100%;
    min-width: 40px;
  }

  .check-icon {
    font-size: 1.5rem;
    margin-left: 3px;
    margin-top: 2px;
  }

  .step-description {
    padding: 1rem;
    font: ${fonts.medium};
    color: ${colors.primary};
    text-align: center;

    transition: 120ms color;
  }

  .step-description.completed {
    color: ${colors.borderInput};

    transition: 120ms color;
  }
  .step-item-container.filled .step-icon {
    background-color: ${colors.text};
    border-color: ${colors.text};
    color: ${colors.white};
  }
  .step-item-container.filled.completed .step-icon {
    background-color: ${colors.primary};
    border-color: ${colors.primary};
    transition: 120ms color;
  }

`